import React, { useState } from 'react';
import Swal from 'sweetalert2';
import { crearProveedor, actualizarProveedor } from '../../services/data';
import '../finanzas/ui.css';

const VACIO = { nombre: '', nombreComercial: '', nit: '', telefono: '', contacto: '', direccion: '', observaciones: '', diasCredito: '', activo: true }; // días de crédito: el 0 es solo placeholder

// Crear o editar proveedor. Los días de crédito alimentan el cálculo automático de vencimientos.
export default function ProveedorFormModal({ proveedor, onClose, onSaved }) {
  const [f, setF] = useState(proveedor ? { ...VACIO, ...proveedor, diasCredito: String(proveedor.diasCredito ?? 0) } : VACIO);
  const [busy, setBusy] = useState(false);
  const set = (k) => (e) => setF({ ...f, [k]: e.target.type === 'checkbox' ? e.target.checked : e.target.value });

  const guardar = async (e) => {
    e.preventDefault();
    if (!f.nombre.trim()) return Swal.fire('Proveedor', 'El nombre es obligatorio.', 'warning');
    if (!/^\d{1,3}$/.test(f.diasCredito)) return Swal.fire('Proveedor', 'Indica los días de crédito: número entero de 0 a 365 (0 = de contado).', 'warning');
    setBusy(true);
    try {
      const payload = { ...f, diasCredito: Number(f.diasCredito) };
      const saved = proveedor ? await actualizarProveedor(proveedor.id, payload) : await crearProveedor(payload);
      onSaved?.(saved);
    } catch (err) { Swal.fire('Error', err.message || 'No se pudo guardar.', 'error'); }
    finally { setBusy(false); }
  };

  return (
    <div className="fx-backdrop" role="presentation" onMouseDown={onClose}>
      <form className="fx-modal fx-modal--sm fx-compacto" role="dialog" aria-modal="true" aria-label={proveedor ? 'Editar proveedor' : 'Crear proveedor'} onSubmit={guardar} onMouseDown={(e) => e.stopPropagation()}>
        <header><h2>{proveedor ? 'Editar proveedor' : 'Crear proveedor'}</h2><button type="button" aria-label="Cerrar" onClick={onClose}>×</button></header>
        <p className="fx-intro">Completa la información. Los campos marcados con * son obligatorios.</p>
        <div className="fx-form">
          <label>Nombre <span className="fx-req" aria-hidden="true">*</span><input value={f.nombre} onChange={set('nombre')} required autoFocus maxLength={200} /></label>
          <label>Nombre comercial<input value={f.nombreComercial} onChange={set('nombreComercial')} maxLength={200} /></label>
          <label>NIT<input value={f.nit} onChange={set('nit')} maxLength={30} /></label>
          <label>Teléfono<input value={f.telefono} onChange={set('telefono')} inputMode="tel" maxLength={40} /></label>
          <label>Contacto<input value={f.contacto} onChange={set('contacto')} maxLength={120} /></label>
          <label>Días de crédito <span className="fx-req" aria-hidden="true">*</span><input value={f.diasCredito} placeholder="0" inputMode="numeric" onChange={(e) => /^\d{0,3}$/.test(e.target.value) && setF({ ...f, diasCredito: e.target.value })} required />
            <span className="fx-help">Se usa para calcular la fecha de vencimiento.</span></label>
          <label className="full">Dirección<input value={f.direccion} onChange={set('direccion')} maxLength={300} /></label>
          <label className="full">Observaciones<textarea rows={2} value={f.observaciones} onChange={set('observaciones')} maxLength={1000} /></label>
          <label className="full fx-check"><input type="checkbox" checked={f.activo} onChange={set('activo')} /> Proveedor activo</label>
        </div>
        {proveedor && <p className="fx-help" style={{ marginTop: 6 }}>Cambiar los días de crédito aplica a compras nuevas; no recalcula documentos ya registrados.</p>}
        <div className="fx-actions"><button type="button" className="fx-btn" onClick={onClose}>Cancelar</button><button className="fx-btn fx-btn--primary" disabled={busy}>{busy ? 'Guardando…' : 'Guardar'}</button></div>
      </form>
    </div>
  );
}
